import { Copy, Droplets, EyeOff, Frown, Eye, PersonStanding } from 'lucide-react';
import { CULL } from '@/constants/testIds';

const base = 'inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-[0.1em] backdrop-blur';

export const CullBadges = ({ image, compact = false }) => {
  const c = image.cull || {};
  const id = image.id;
  const items = [];
  if (c.blurry) items.push({ kind: 'blurry', label: 'Blurry', Icon: Droplets, cls: 'border-red-400/50 bg-red-950/70 text-red-200' });
  if (c.eyes_closed) items.push({ kind: 'eyes', label: 'Eyes closed', Icon: Eye, cls: 'border-rose-300/50 bg-rose-950/70 text-rose-200' });
  else if (c.expression_issue) items.push({ kind: 'expression', label: 'Expression', Icon: Frown, cls: 'border-orange-300/50 bg-orange-950/70 text-orange-200' });
  if (c.posing_issue) items.push({ kind: 'posing', label: 'Posing', Icon: PersonStanding, cls: 'border-amber-300/50 bg-amber-950/70 text-amber-200' });
  if (c.duplicate_group) items.push({ kind: 'duplicate', label: compact ? 'Dup' : `Dup ${c.duplicate_group.replace('g', '#')}`, Icon: Copy, cls: 'border-[hsl(var(--lxra-gold))]/60 bg-[#0A0A0A]/80 text-[hsl(var(--lxra-gold))]' });
  if (image.hidden) items.push({ kind: 'hidden', label: 'Hidden', Icon: EyeOff, cls: 'border-[hsl(var(--lxra-border))] bg-[#0A0A0A]/80 text-[hsl(var(--lxra-muted))]' });
  if (!items.length) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {items.map(({ kind, label, Icon, cls }) => (
        <span key={kind} data-testid={CULL.badge(id, kind)} className={`${base} ${cls}`}><Icon className="h-2.5 w-2.5" /> {label}</span>
      ))}
    </div>
  );
};
